import { render, staticRenderFns } from "./Ryvyl.vue?vue&type=template&id=071d09b2&scoped=true&"
import script from "./Ryvyl.vue?vue&type=script&lang=js&"
export * from "./Ryvyl.vue?vue&type=script&lang=js&"
import style0 from "./Ryvyl.vue?vue&type=style&index=0&id=071d09b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d09b2",
  null
  
)

export default component.exports